<template>
  <div ref="playerWindow" class="playerWrapper" :class="{ expandWindow: isExpand, hideFloatingBtn: isExpand && fsm === 'TOP' }" :style="{ background: bgStyle }" @keydown.esc="onEsc">
    <div class="mainWin">
      <PlayCore ref="pgPanel" :isExpand="isExpand" :song="song"/>
    </div>
    <transition name="player-expand">
      <div v-if="isExpand" class="expandedOverlay" ref="scrollEl" @wheel="onWheel">
      <button class="closeBtn" @click="closePlayer" title="关闭 (Esc)">
        <BaseIcon name="close"/>
      </button>

      <section class="heroSection">
        <div class="heroLeft">
          <div class="coverWrapper">
            <div class="coverGlow"></div>
            <div class="coverArt">
              <img ref="coverImg" :src="coverUrl | imgParam('400y400')" alt="" @load="onCoverLoad" crossorigin="anonymous" class="playerCover" />
            </div>
          </div>
          <div class="songMeta">
            <h1 class="songTitle">{{ songName }}</h1>
            <p class="songArtist" @click="arClick">{{ artistNames }}</p>
            <p v-if="albumName" class="songAlbum" @click="alClick">{{ albumName }}</p>
          </div>
          <div class="progressSection" ref="progressPanel">
            <div class="progressTrack" @click="progressClk">
              <div class="progressBuffer" :style="{ width: bufferPercent + '%' }"></div>
              <div class="progressFill" :style="{ width: progressPercent + '%' }"><div class="progressThumb" @mousedown.stop="dragProgress"></div></div>
            </div>
            <div class="progressTimes"><span>{{ formatTime(timeNow) }}</span><span>{{ formatTime(duration) }}</span></div>
          </div>
          <div class="controlsRow">
            <span
                class="modeBtn"
                :class="'mode-' + playMode"
                :title="playMode === 'order' ? '列表循环' : playMode === 'random' ? '随机播放' : '单曲循环'"
                @click="togglePlayMode"
            >
              <BaseIcon v-if="playMode === 'order'" name="loopList" :size="20"/>
              <BaseIcon v-else-if="playMode === 'random'" name="shuffle" :size="20"/>
              <BaseIcon v-else-if="playMode === 'sequence'" name="sequence" :size="20"/>
              <BaseIcon v-else name="loopOne" :size="20"/>
            </span>
            <span class="trackBtn prevBtn" @click="prevTrack"><BaseIcon name="prev" :size="20"/></span>
            <div class="playBtn" @click="togglePlay"><i v-if="isLoading" class="player-loading-spinner"></i><BaseIcon v-else-if="!isPlaying" name="play"/><BaseIcon v-else name="pause"/></div>
            <span class="trackBtn nextBtn" @click="nextTrack"><BaseIcon name="next" :size="20"/></span>
            <span class="modeBtn mode-spacer"></span>
          </div>
          <div class="actionsRow">
            <button class="actionBtn" :class="{ active: isLiked }" @click="toggleLike"><BaseIcon :name="isLiked ? 'likeFill' : 'like'"/><span>喜欢</span></button>
            <button class="actionBtn" :disabled="downloading" @click="downloadSong"><BaseIcon name="download"/><span>{{ downloading ? '获取中' : '下载' }}</span></button>
            <button class="actionBtn" @click="shareSong"><BaseIcon name="share"/><span>分享</span></button>
          </div>
        </div>
        <div class="heroRight">
          <div class="rightTabs">
            <span :class="{ active: rightTab === 'lyric' }" @click="rightTab = 'lyric'"><BaseIcon name="radio"/> 歌词</span>
            <span :class="{ active: rightTab === 'tracks' }" @click="rightTab = 'tracks'"><BaseIcon name="play"/> 相似歌曲</span>
            <span :class="{ active: rightTab === 'playlist' }" @click="rightTab = 'playlist'"><BaseIcon name="share"/> 相似歌单</span>
          </div>
          <div class="rightContent">
            <div v-show="rightTab === 'lyric'" class="tabPanel">
              <div v-if="!lyric.length" class="panelEmpty"><p>暂无歌词</p><p class="emptyHint">纯音乐，请欣赏</p></div>
              <div v-else class="lyricsScroll" ref="lyricsScroll">
                <div class="lyricsInner">
                  <p v-for="(line, idx) in lyric" :key="idx" :class="{ active: line.cur, spacer: !line.lytxt || line.lytxt === '<br>' }" @click="lyricClick(line.t)">
                    <template v-if="line.words && line.words.length">
                      <span v-for="(w, wi) in line.words" :key="wi" class="lyricWord" :class="{ on: line.wcur >= wi }">{{ w.txt }}</span>
                    </template>
                    <span v-else v-html="line.lytxt || '&nbsp;'"></span>
                    <span v-if="line.tr" class="lyricTr">{{ line.tr }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div v-show="rightTab === 'tracks'" class="tabPanel">
              <div v-if="!simiTracks.length" class="panelEmpty"><p>暂无相似歌曲</p></div>
              <div v-else class="cardScroll"><div v-for="t in simiTracks" :key="t.id" class="musicCard" @click="playSimilarTrack(t)"><div class="cardCover"><img :src="trackAlbumPic(t) | imgParam('200y200')" loading="lazy" /><div class="cardOverlay"><BaseIcon name="play" :size="34"/></div></div><p class="cardTitle">{{ t.name }}</p><p class="cardSubtitle">{{ trackArtists(t) }}</p></div></div>
            </div>
            <div v-show="rightTab === 'playlist'" class="tabPanel">
              <div v-if="!simiPlaylist.length" class="panelEmpty"><p>暂无相似歌单</p></div>
              <div v-else class="cardScroll"><div v-for="pl in simiPlaylist" :key="pl.id" class="musicCard" @click="plClk(pl.id)"><div class="cardCover"><img :src="(pl.coverImgUrl || pl.picUrl) | imgParam('200y200')" loading="lazy" /><div class="cardOverlay"><BaseIcon name="play" :size="34"/></div></div><p class="cardTitle">{{ pl.name }}</p><p class="cardSubtitle">{{ pl.creator && pl.creator.nickname || '' }}</p></div></div>
            </div>
          </div>
        </div>
      </section>

      <section class="commentsSection" ref="commentsSection">
        <div class="sectionHeader" ref="commentsAnchor"><h2>评论</h2></div>
        <div ref="commentsContent">
          <CommentLayout :id="currentSong.id" type="0" @modal-open="onCommentModalOpen" @modal-close="onCommentModalClose"/>
        </div>
      </section>
    </div>
    </transition>

    <!-- Overlay buttons -->
    <button v-if="isExpand && fsm === 'TOP'" class="overlayBtn bottomBtn" @click="scrollToComments">
      <BaseIcon name="arrowDown"/> 查看评论
    </button>
    <button v-if="isExpand && fsm !== 'TOP'" class="overlayBtn topBtn" @click="scrollToTop">
      <BaseIcon name="arrowUp"/> 返回顶部
    </button>
  </div>
</template>

<script>
import PlayCore from "@/components/musicPlayer/PlayerCore";
import CommentLayout from "@/components/layout/CommentLayout";
import { buildBackground } from "@/utils/colorExtractor";
import { parseLyricData, parseLrcText, findActiveIndex, findActiveWord } from "@/utils/lyric";
import config from "@/config";
import * as tracksApi from "@/api/Tracks";

export default {
  name: "MusicPlayer",
  props: ['song'],
  components: { PlayCore, CommentLayout },
  data() {
    return {
      isExpand: false,
      isModalOpen: false,
      lyric: [],
      // 下载按钮请求中标志，防止连点
      downloading: false,
      timeNow: 0,
      currentSong: {},
      simiTracks: [],
      simiPlaylist: [],
      // 大播放器的红心状态：由 PlayerCore emit('likeChange') 同步
      // 不在本地另存数据，避免双份状态不一致
      likeMirror: false,
      rightTab: 'lyric',
      lastActiveIdx: -1,
      bgStyle: 'linear-gradient(170deg, #1a1a2e 0%, #0f0f23 100%)',
      fsm: 'TOP',
      scrollObserver: null,
      wheelAccum: 0,
      transitioning: false,
      colorSongId: null,
    }
  },
  computed: {
    coverUrl() {
      const s = this.currentSong
      return (s.al && s.al.picUrl) || (s.album && s.album.picUrl) || ''
    },
    songName() { return this.currentSong.name || '未知歌曲' },
    artistNames() {
      const s = this.currentSong; const ar = s.ar || s.artists
      if (!ar) return '未知歌手'
      if (typeof ar === 'string') return ar || '未知歌手'
      if (Array.isArray(ar)) return ar.map(a => a.name || a).join(' / ')
      return '未知歌手'
    },
    albumName() {
      const s = this.currentSong
      return (s.al && s.al.name) || (s.album && s.album.name) || ''
    },
    duration() { return this.$refs.pgPanel ? this.$refs.pgPanel.timeDuration * 1 : 0 },
    isPlaying() { return this.$refs.pgPanel ? this.$refs.pgPanel.isPlay : false },
    isLoading() { return this.$refs.pgPanel ? this.$refs.pgPanel.isLoading : false },
    bufferedTime() { return this.$refs.pgPanel ? this.$refs.pgPanel.bufferedTime : 0 },
    playMode() { return this.$refs.pgPanel ? this.$refs.pgPanel.playMode : 'order' },
    progressPercent() { return this.duration ? (this.timeNow / this.duration) * 100 : 0 },
    bufferPercent() { return this.duration ? (this.bufferedTime / this.duration) * 100 : 0 },
    // 红心状态来自 PlayerCore（单一数据源），这里镜像同步
    isLiked() { return this.likeMirror },
  },
  watch: {
    isExpand(val) {
      val ? this.expanded() : this.minified()
      this._rememberUi()
    },
    timeNow(val) { this.needUpdate(val) },
    rightTab() { this._rememberUi() },
    coverUrl(url) { if (url) this.$nextTick(() => this.updateBackground()) },
    '$route'() { if (this.isExpand) this.isExpand = false },
  },
  methods: {
    showSongDetail(data) {
      this.isExpand = true
      this.currentSong = data
      this.rightTab = 'lyric'
      this.lastActiveIdx = -1
      this.fsm = 'TOP'
      this.wheelAccum = 0
      this.colorSongId = null
    },
    expanded() {
      document.body.style.overflow = 'hidden'
      this.$refs.pgPanel.$on('tUpdate', (t) => this.timeUpdate(t))
      this.$nextTick(() => this.setupScrollObserver())
    },
    minified() {
      document.body.style.overflow = ''
      this.$refs.pgPanel.$off('tUpdate')
      if (this.scrollObserver) { this.scrollObserver.disconnect(); this.scrollObserver = null }
    },
    closePlayer() {
      if (this.isModalOpen) {
        this.isModalOpen = false
        return
      }
      this.isExpand = false
    },
    onEsc() {
      if (this.isModalOpen) {
        this.isModalOpen = false
        return
      }
      this.isExpand = false
    },
    onCommentModalOpen() { this.isModalOpen = true },
    onCommentModalClose() { this.isModalOpen = false },

    /**
     * 大播放器的界面状态用 sessionStorage：刷新要保留（"我刚在看歌词"），
     * 关掉标签页就该忘掉（下次打开不该凭空弹一个全屏播放器）。
     * 不用 localStorage —— 那是长期偏好，全屏展开属于这一次的会话状态。
     */
    _rememberUi() {
      try {
        sessionStorage.setItem('acmusic_player_ui', JSON.stringify({ expand: this.isExpand, rightTab: this.rightTab }))
      } catch (e) { /* ignore */ }
    },
    _restoreUi() {
      let saved = null
      try { saved = JSON.parse(sessionStorage.getItem('acmusic_player_ui') || 'null') } catch (e) { saved = null }
      if (!saved) return
      if (['lyric', 'tracks', 'playlist'].indexOf(saved.rightTab) !== -1) this.rightTab = saved.rightTab
      const pg = this.$refs.pgPanel
      // 没有在播的歌别硬撑全屏；PlayerCore 是子组件，mounted 顺序保证它的队列已恢复完
      if (saved.expand && pg && pg.currentSong && pg.currentSong.id) {
        this.currentSong = pg.currentSong
        this.isExpand = true
      }
    },

    setupScrollObserver() {
      if (this.scrollObserver) this.scrollObserver.disconnect()
      const scroller = this.$refs.scrollEl
      if (!scroller) return
      this.scrollObserver = new IntersectionObserver(() => {
        if (this.transitioning || !scroller) return
        const top = scroller.scrollTop
        if (top <= 20 && this.fsm !== 'TOP') this.fsm = 'TOP'
      }, { threshold: [0, 0.01] })
      this.scrollObserver.observe(scroller)
    },

    onWheel(e) {
      const scroller = this.$refs.scrollEl
      if (!scroller) return
      if (this.transitioning) { e.preventDefault(); return }

      if (this.fsm === 'TOP' && e.deltaY > 0) {
        this.wheelAccum += e.deltaY
        if (this.wheelAccum > 50) { this.wheelAccum = 0; e.preventDefault(); this.scrollToComments() }
        return
      }

      if (this.fsm === 'BOTTOM_LOCK' && e.deltaY < 0) {
        const anchor = this.$refs.commentsAnchor
        if (!anchor) return
        const anchorTop = anchor.getBoundingClientRect().top + scroller.scrollTop
        const nearTop = scroller.scrollTop <= anchorTop + 100
        if (nearTop) {
          e.preventDefault()
          this.wheelAccum += Math.abs(e.deltaY)
          if (this.wheelAccum > 60) { this.wheelAccum = 0; this.fsm = 'RETURNING'; this.scrollToTop() }
          return
        }
      }
    },

    scrollToComments() {
      const anchor = this.$refs.commentsAnchor
      const scroller = this.$refs.scrollEl
      if (!anchor || !scroller) return
      this.transitioning = true; this.wheelAccum = 0
      const target = anchor.getBoundingClientRect().top + scroller.scrollTop
      const start = scroller.scrollTop; const dist = target - start
      const t0 = performance.now()
      const step = (now) => {
        const p = Math.min((now - t0) / 400, 1)
        scroller.scrollTop = start + dist * (1 - Math.pow(1 - p, 3))
        if (p < 1) requestAnimationFrame(step)
        else { this.fsm = 'BOTTOM_LOCK'; this.transitioning = false }
      }
      requestAnimationFrame(step)
    },

    scrollToTop() {
      const scroller = this.$refs.scrollEl
      if (!scroller) return
      this.transitioning = true; this.wheelAccum = 0
      const start = scroller.scrollTop
      const t0 = performance.now()
      const step = (now) => {
        const p = Math.min((now - t0) / 400, 1)
        scroller.scrollTop = start * (1 - (1 - Math.pow(1 - p, 3)))
        if (p < 1) requestAnimationFrame(step)
        else { this.fsm = 'TOP'; this.transitioning = false }
      }
      requestAnimationFrame(step)
    },

    onCoverLoad() { this.updateBackground() },
    updateBackground() {
      const img = this.$refs.coverImg
      if (!img || !img.complete) return
      const sid = this.currentSong.id
      if (!sid || sid === this.colorSongId) return
      this.colorSongId = sid
      this.bgStyle = buildBackground(img)
    },
    getLyric(id) {
      this.lyric = []; this.lastActiveIdx = -1
      // 旧接口兜底：/lyric 只给标准 LRC，但覆盖最广
      const legacy = () => tracksApi.lyric(id).then(res => {
        const text = res && res.data && res.data.lrc && res.data.lrc.lyric
        this.lyric = text ? parseLrcText(text) : []
      }).catch(() => { this.lyric = [] })

      tracksApi.lyricNew(id).then(res => {
        const rows = parseLyricData(res && res.data)
        if (rows.length) this.lyric = rows
        else return legacy()
      }).catch(() => legacy())
    },
    timeUpdate(t) { this.timeNow = t * 1 },
    lyricClick(t) {
      const panel = this.$refs.pgPanel
      if (!panel) return
      t + 0.1 > panel.timeDuration ? panel.sel.currentTime = panel.timeDuration : panel.sel.currentTime = t + 0.01
    },
    needUpdate(val) {
      if (!this.lyric.length) return
      // 当前行 = 最后一个 t <= 播放进度 的行（旧实现取的是"下一行"，会导致高亮提前一行）
      const curIdx = findActiveIndex(this.lyric, val)
      if (curIdx !== this.lastActiveIdx) {
        this.lyric.forEach((ly, i) => {
          const on = i === curIdx
          if (ly.cur !== on) ly.cur = on
        })
        this.lastActiveIdx = curIdx
        this.$nextTick(() => {
          const container = this.$refs.lyricsScroll
          if (!container) return
          const active = container.querySelector('p.active')
          if (active) {
            const targetTop = active.offsetTop - container.clientHeight / 2 + active.clientHeight / 2
            container.scrollTo({ top: targetTop, behavior: 'smooth' })
          }
        })
      }
      // 逐字进度：仅对 yrc 行生效，wcur 之前的字点亮
      const line = curIdx >= 0 ? this.lyric[curIdx] : null
      if (line && line.words && line.words.length) {
        const wi = findActiveWord(line, val)
        if (line.wcur !== wi) line.wcur = wi
      }
    },
    getSimiTracks(id) { return tracksApi.simiTracks(id) },
    getSimiPlaylist(id) { return tracksApi.simiPlaylist(id) },
    concurrentRequestsGetSimi(id) {
      this.$axios.all([this.getSimiTracks(id), this.getSimiPlaylist(id)])
        .then(this.$axios.spread((tracks, list) => {
          this.simiTracks = tracks.data.songs || []
          this.simiPlaylist = list.data.playlists || []
        })).catch(err => { console.error(err.message) })
    },
    togglePlay() { const p = this.$refs.pgPanel; if (p) p.isPlay ? p.pauseSong() : p.playSong() },
    prevTrack() { if (this.$refs.pgPanel) this.$refs.pgPanel.preSong() },
    nextTrack() { if (this.$refs.pgPanel) this.$refs.pgPanel.nextSong() },
    togglePlayMode() { if (this.$refs.pgPanel) this.$refs.pgPanel.togglePlayMode() },
    toggleLike() {
      // 委托给 PlayerCore（单一数据源，含 likePending 锁 + API 调用 + 失败回滚）
      if (this.$refs.pgPanel) this.$refs.pgPanel.toggleLike()
    },
    /**
     * 下载当前歌曲。
     * 走 /song/download/url/v1（客户端下载接口），需要登录；无权限时 data.code = -110、url 为 null。
     * 浏览器对跨域 URL 的 download 属性无效，所以只保证触发下载/新标签打开，不做二次转存。
     */
    downloadSong() {
      const song = this.currentSong || {}
      if (!song.id) return
      if (this.downloading) return
      this.downloading = true
      const level = config.player.level || 'standard'
      tracksApi.downloadUrlV1(song.id, level).then(res => {
        const d = (res && res.data && res.data.data) || {}
        const url = d.url
        if (!url) {
          if (d.code === -110) this.$toast.warning('下载需要先登录，登录后重试')
          else this.$toast.warning('该歌曲暂不提供下载，版权方未开放')
          return
        }
        const a = document.createElement('a')
        a.href = url
        a.download = `${song.name || 'song'}${d.type ? '.' + d.type : '.mp3'}`
        a.target = '_blank'
        a.rel = 'noopener'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        this.$toast.success('已开始下载')
      }).catch(err => {
        console.warn('[Download]', err && err.message)
        this.$toast.warning('下载失败，请稍后重试')
      }).then(() => { this.downloading = false })
    },
    shareSong() {},
    formatTime(s) { s = s * 1; if (!s || isNaN(s)) return '00:00'; const m = Math.floor(s / 60); return String(m).padStart(2, '0') + ':' + String(Math.floor(s % 60)).padStart(2, '0') },
    trackAlbumPic(t) { return (t.album && t.album.picUrl) || (t.al && t.al.picUrl) || '' },
    trackArtists(t) { const ar = t.ar || t.artists; return ar && ar.length ? ar.map(a => a.name).join(' / ') : '' },
    playSimilarTrack(t) { this.$bus.$emit('songClk', t) },
    arClick() { const ar = (this.currentSong.ar || this.currentSong.artists); if (ar && ar[0]) this.$bus.$emit('arClk', ar[0].id) },
    alClick() { const id = (this.currentSong.al && this.currentSong.al.id) || (this.currentSong.album && this.currentSong.album.id); if (id) this.$bus.$emit('alClk', id) },
    plClk(id) { this.$bus.$emit('plClk', id) },
    progressClk(evt) {
      const p = this.$refs.pgPanel; if (!p || !this.$refs.progressPanel) return
      const r = this.$refs.progressPanel.getBoundingClientRect()
      p.sel.currentTime = Math.max(0, Math.min(1, (evt.clientX - r.left) / r.width)) * this.duration
    },
    dragProgress(evt) {
      const p = this.$refs.pgPanel; if (!p || !this.$refs.progressPanel) return
      const onMove = (e) => { const r = this.$refs.progressPanel.getBoundingClientRect(); p.sel.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * this.duration }
      document.addEventListener('mousemove', onMove)
      document.addEventListener('mouseup', () => document.removeEventListener('mousemove', onMove), { once: true })
      evt.preventDefault()
    },
  },
  mounted() {
    this.$refs.pgPanel.$on('SDClk', this.showSongDetail)
    this.$refs.pgPanel.$on('songChange', (s) => { this.currentSong = s; this.lastActiveIdx = -1; this.colorSongId = null })
    this.$refs.pgPanel.$on('getLyric', this.getLyric)
    this.$refs.pgPanel.$on('getSimi', this.concurrentRequestsGetSimi)
    // 同步 PlayerCore 的红心状态（用户点击会触发 PlayerCore.toggleLike()）
    this.$refs.pgPanel.$on('likeChange', ({ liked }) => { this.likeMirror = liked })
    // 初始化镜像状态（已加载歌曲）
    if (this.$refs.pgPanel.currentSong && this.$refs.pgPanel.currentSong.id) {
      this.likeMirror = !!this.$refs.pgPanel.isLiked
    }
    this._restoreUi()
  },
  beforeDestroy() {
    if (this.scrollObserver) this.scrollObserver.disconnect()
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/base/variables";
@import "../../assets/scss/base/motion";

.playerWrapper {
  transition: background $motion-slow $ease-smooth;
}

.playerWrapper {
  .expandedOverlay { display: none; }
}

// Player Expand Transition (CSS-based, Vue 2 transition classes)
.player-expand-enter-active,
.player-expand-leave-active {
  transition: opacity $motion-normal $ease-standard, transform $motion-normal $ease-standard;
}

.player-expand-enter {
  opacity: 0;
  transform: scale($player-expand-scale) translateY($player-expand-shift);
}

.player-expand-enter-to {
  opacity: 1;
  transform: scale(1) translateY(0);
}

.player-expand-leave-to {
  opacity: 0;
  transform: scale(.98) translateY($player-expand-shift);
}

// Cover Animation (expanded 进入时从缩放到完整)
.expandWindow .playerCover {
  transition: transform $motion-normal $ease-standard, opacity $motion-normal $ease-standard;
  transform: scale(1);
  opacity: 1;
}
.player-expand-enter .playerCover {
  transform: scale(.92);
  opacity: .8;
}

.playerWrapper.expandWindow {
  position: fixed; inset: 0; z-index: 200;

  .mainWin { display: none; }

  .expandedOverlay {
    display: block; width: 100%; height: 100%;
    overflow-y: auto; overflow-x: hidden;
    &::-webkit-scrollbar { width: 4px; }
    &::-webkit-scrollbar-track { background: transparent; }
    &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.10); border-radius: 2px; }
  }

  .closeBtn {
    position: fixed; top: 28px; right: 36px; z-index: 20;
    width: 44px; height: 44px; border-radius: 50%;
    border: 1px solid rgba(255,255,255,0.08); background: rgba(255,255,255,0.05);
    color: rgba(255,255,255,0.5); font-size: 20px; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    backdrop-filter: blur(12px); transition: all 220ms ease;
    &:hover { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.85); transform: scale(1.05); }
  }

  .heroSection {
    display: flex; align-items: center; min-height: 100vh;
    gap: 5%; padding: 60px 5% 60px 6%; box-sizing: border-box;
    max-width: 1400px; margin: 0 auto;
  }

  .heroLeft {
    flex: 0 0 32%; max-width: 360px; min-width: 260px;
    display: flex; flex-direction: column; align-items: center; gap: 18px;
  }

  .coverWrapper {
    position: relative; width: 260px; height: 260px; flex-shrink: 0;
  .coverGlow { position: absolute; inset: -30px; border-radius: 50%; background: radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 70%); filter: blur(50px); pointer-events: none; }
  .coverArt { position: relative; width: 100%; height: 100%; border-radius: 16px; overflow: hidden; box-shadow: 0 16px 48px rgba(0,0,0,0.35); img { width: 100%; height: 100%; object-fit: cover; display: block; transition: transform .3s ease, opacity .3s ease; } }
  .coverArt img { transform: scale(1); opacity: 1; }
  }

  .songMeta {
    text-align: center; width: 100%;
    .songTitle { font-size: 24px; font-weight: 700; color: rgba(255,255,255,0.92); line-height: 1.3; margin: 0 0 6px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 0 8px; }
    .songArtist { font-size: 15px; font-weight: 500; color: rgba(255,255,255,0.5); cursor: pointer; margin: 0 0 3px; &:hover { color: #8685EF; } }
    .songAlbum { font-size: 13px; color: rgba(255,255,255,0.32); cursor: pointer; margin: 0; &:hover { color: rgba(255,255,255,0.5); } }
  }

  .progressSection {
    width: 100%; max-width: 300px;
    .progressTrack { width: 100%; height: 4px; background: rgba(255,255,255,0.08); border-radius: 2px; cursor: pointer; position: relative; &:hover { height: 6px; }
      .progressBuffer { position: absolute; inset: 0; height: 100%; background: rgba(255,255,255,0.1); border-radius: inherit; pointer-events: none; }
      .progressFill { height: 100%; background: #8685EF; border-radius: inherit; position: relative; transition: width 0.1s linear; box-shadow: 0 0 8px rgba(134,133,239,0.2);
        .progressThumb { position: absolute; right: -6px; top: 50%; transform: translateY(-50%); width: 14px; height: 14px; background: #fff; border-radius: 50%; box-shadow: 0 1px 6px rgba(0,0,0,0.4); opacity: 0; transition: opacity 180ms ease; }
      }
      &:hover .progressFill .progressThumb { opacity: 1; }
    }
    .progressTimes { display: flex; justify-content: space-between; margin-top: 7px; font-size: 11px; color: rgba(255,255,255,0.34); font-variant-numeric: tabular-nums; letter-spacing: .2px; }
  }

  .controlsRow {
    display: flex; align-items: center; justify-content: center; gap: 18px; color: rgba(255,255,255,0.85);
    .trackBtn {
      display: inline-flex; align-items: center; justify-content: center;
      width: 36px; height: 36px; border-radius: 50%;
      background: rgba(255,255,255,0.06);
      border: 1px solid rgba(255,255,255,0.08);
      cursor: pointer;
      transition: all 180ms ease;
      &:hover { background: rgba(255,255,255,0.12); transform: scale(1.1); }
      &:active { transform: scale(0.94); }
    }
    // 与切歌按钮同尺寸、但不给底色：模式是次级控件，悬停才浮出背景
    .modeBtn {
      display: inline-flex; align-items: center; justify-content: center;
      width: 36px; height: 36px; border-radius: 50%;
      border: 1px solid transparent;
      cursor: pointer;
      color: rgba(255,255,255,0.42);
      transition: all 180ms ease;
      &.mode-random, &.mode-loop { color: #8685EF; }
      &:hover {
        color: rgba(255,255,255,0.9);
        background: rgba(255,255,255,0.07);
        border-color: rgba(255,255,255,0.06);
      }
      &.mode-random:hover, &.mode-loop:hover { color: #8685EF; }
      &.mode-spacer { pointer-events: none; border-color: transparent; background: none; }
    }
    .playBtn { width: 44px; height: 44px; border-radius: 50%; background: #8685EF; color: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: 0 4px 20px rgba(134,133,239,0.35); transition: all 220ms ease; i { font-size: 20px; } .player-loading-spinner { display: block; width: 18px; height: 18px; border: 2px solid rgba(255,255,255,.3); border-top-color: #fff; border-radius: 50%; animation: player-loading-spin .8s linear infinite; } &:hover { transform: scale(1.06); box-shadow: 0 6px 28px rgba(134,133,239,0.5); } &:active { transform: scale(0.95); } }
  }

  .actionsRow {
    display: flex; align-items: center; justify-content: center; gap: 10px;
    .actionBtn {
      display: inline-flex; align-items: center; justify-content: center; gap: 6px;
      height: 32px; padding: 0 16px;
      border-radius: 16px;
      border: 1px solid rgba(255,255,255,0.08);
      background: rgba(255,255,255,0.04);
      color: rgba(255,255,255,0.5);
      font-size: 12px; line-height: 1;
      font-family: inherit;
      cursor: pointer;
      transition: all 180ms ease;
      i { font-size: 15px; }
      &:hover { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.82); border-color: rgba(255,255,255,0.16); }
      &:disabled { opacity: 0.5; cursor: not-allowed; }
      &.active {
        color: rgba(255,255,255,0.92);
        border-color: rgba(134,133,239,0.3);
        background: rgba(134,133,239,0.12);
        i { color: #ef4444; }
      }
    }
  }

  .heroRight { flex: 1; min-width: 0; align-self: stretch; display: flex; flex-direction: column; }

  .rightTabs {
    display: flex; border-bottom: 1px solid rgba(255,255,255,0.06); flex-shrink: 0;
    span { padding: 12px 20px; font-size: 13px; color: rgba(255,255,255,0.35); cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -1px; transition: all 180ms ease; display: flex; align-items: center; gap: 5px; i { font-size: 14px; } &:hover { color: rgba(255,255,255,0.6); } &.active { color: rgba(255,255,255,0.88); font-weight: 600; border-bottom-color: #8685EF; } }
  }

  .rightContent { flex: 1; min-height: 0; overflow: hidden; padding-top: 16px; }
  .tabPanel { height: 100%; overflow: hidden; }

  .lyricsScroll {
    max-height: calc(70vh - 120px); height: calc(70vh - 120px);
    overflow-y: auto; position: relative;
    mask-image: linear-gradient(to bottom, transparent 0%, black 5%, black 95%, transparent 100%);
    -webkit-mask-image: linear-gradient(to bottom, transparent 0%, black 5%, black 95%, transparent 100%);
    &::-webkit-scrollbar { width: 4px; } &::-webkit-scrollbar-track { background: transparent; } &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 2px; }
    .lyricsInner { padding: 40vh 0; }
    p { font-size: 16px; line-height: 2.5; color: rgba(255,255,255,0.28); text-align: center; cursor: pointer; transition: all 400ms cubic-bezier(0.22,0.61,0.36,1); margin: 0; padding: 0 16px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; &:hover { color: rgba(255,255,255,0.45); } &.active { font-size: 26px; font-weight: 700; color: rgba(255,255,255,0.92); line-height: 2; } &.spacer { height: 10px; font-size: 0; } }
    /* 逐字（yrc）：未唱到的字压暗，唱到的字提亮 */
    .lyricWord { opacity: .45; transition: opacity 120ms linear, color 120ms linear; }
    .lyricWord.on { opacity: 1; }
    p.active .lyricWord.on { color: #fff; text-shadow: 0 0 14px rgba(134,133,239,0.5); }
    /* 翻译副行 */
    .lyricTr { display: block; font-size: .6em; font-weight: 400; line-height: 1.7; color: rgba(255,255,255,0.5); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    p.active .lyricTr { color: rgba(255,255,255,0.62); }
  }

  .panelEmpty { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; min-height: 200px; color: rgba(255,255,255,0.28); p { margin: 0; font-size: 15px; } .emptyHint { font-size: 13px; opacity: 0.5; margin-top: 6px; } }

  .cardScroll { display: flex; gap: 14px; overflow-x: auto; padding: 8px 0; scroll-snap-type: x mandatory; height: 100%; align-content: flex-start; flex-wrap: wrap; &::-webkit-scrollbar { height: 4px; } &::-webkit-scrollbar-track { background: transparent; } &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.08); border-radius: 2px; } }

  .musicCard { flex: 0 0 150px; width: 150px; scroll-snap-align: start; cursor: pointer; transition: transform 250ms cubic-bezier(0.22,0.61,0.36,1); &:hover { transform: translateY(-6px); .cardOverlay { opacity: 1; } .cardCover img { transform: scale(1.06); } }
    .cardCover { position: relative; width: 150px; height: 150px; border-radius: 12px; overflow: hidden; margin-bottom: 10px; background: rgba(255,255,255,0.05); img { width: 100%; height: 100%; object-fit: cover; display: block; transition: transform 400ms cubic-bezier(0.22,0.61,0.36,1); } .cardOverlay { position: absolute; inset: 0; background: rgba(0,0,0,0.35); display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 250ms ease; i { font-size: 34px; color: #fff; filter: drop-shadow(0 2px 8px rgba(0,0,0,0.3)); } } }
    .cardTitle { font-size: 13px; font-weight: 600; color: rgba(255,255,255,0.85); margin: 0 0 3px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } .cardSubtitle { font-size: 11px; color: rgba(255,255,255,0.32); margin: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  }

  .commentsSection {
    padding: 80px 6% 120px; box-sizing: border-box; max-width: 1400px; margin: 0 auto;
    border-top: 1px solid rgba(255,255,255,0.06);
    .sectionHeader { margin-bottom: 28px; h2 { font-size: 22px; font-weight: 700; color: rgba(255,255,255,0.88); margin: 0; } }
    .comment-container {
      .comment-header-bar { display: none; }
      .section-divider { background: linear-gradient(to right, rgba(255,255,255,0.08), transparent); }
      .empty-state p { color: rgba(255,255,255,.28); }
      .load-more {
        button { background: rgba(255,255,255,.06); border-color: rgba(255,255,255,.08); color: rgba(255,255,255,.5); &:hover { background: rgba(255,255,255,.1); } }
        p { color: rgba(255,255,255,.3); }
      }
      .comment-content .comment-item {
        .main { .name { color: rgba(255,255,255,0.8); .nickname { color: rgba(255,255,255,0.45); &:hover { color: #8685EF; } } } .content { color: rgba(255,255,255,0.7); }
          .time-ribbon { .ribbon > span { color: rgba(255,255,255,0.3); &:hover { color: rgba(255,255,255,0.55); } } .comment-delete .el-button { color: rgba(255,255,255,0.3); &:hover { color: #ef4444; } } }
        }
      }
    }
  }

  .overlayBtn {
    position: fixed; z-index: 30;
    display: flex; align-items: center; gap: 6px;
    padding: 10px 24px; border-radius: 24px;
    border: 1px solid rgba(255,255,255,0.1);
    background: rgba(30,30,46,0.85); color: rgba(255,255,255,0.7);
    font-size: 13px; font-weight: 500; cursor: pointer;
    backdrop-filter: blur(12px);
    transition: all 220ms cubic-bezier(0.22,0.61,0.36,1);
    i { font-size: 16px; }
    &:hover { background: rgba(40,40,60,0.9); color: rgba(255,255,255,0.9); transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.3); }
    &.bottomBtn { bottom: 32px; left: 50%; transform: translateX(-50%); &:hover { transform: translateX(-50%) translateY(-2px); } }
    &.topBtn { top: 36px; left: 50%; transform: translateX(-50%); &:hover { transform: translateX(-50%) translateY(-2px); } }
  }
}

.playerWrapper.expandWindow.hideFloatingBtn .floating-comment-btn {
  display: none !important;
}

@keyframes player-loading-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@media (max-width: 1280px) {
  .playerWrapper.expandWindow {
    .heroSection { gap: 3%; padding: 60px 4% 60px 5%; }
    .heroLeft { flex: 0 0 30%; min-width: 240px; }
    .coverWrapper { width: 220px; height: 220px; }
    .lyricsScroll { max-height: calc(70vh - 140px); height: calc(70vh - 140px); p { font-size: 14px; &.active { font-size: 22px; } } }
    .musicCard { flex: 0 0 130px; width: 130px; .cardCover { width: 130px; height: 130px; } }
    .commentsSection { padding: 80px 5% 100px; }
  }
}

@media (max-width: 1024px) {
  .playerWrapper.expandWindow {
    .heroSection { flex-direction: column; gap: 32px; min-height: auto; padding: 100px 32px 60px; }
    .heroLeft { flex: 0 0 auto; width: 100%; max-width: 280px; }
    .coverWrapper { width: 200px; height: 200px; }
    .heroRight { width: 100%; min-height: 50vh; }
    .lyricsScroll { max-height: calc(60vh - 100px); height: calc(60vh - 100px); .lyricsInner { padding: 20vh 0; } }
    .musicCard { flex: 0 0 120px; width: 120px; .cardCover { width: 120px; height: 120px; } }
    .commentsSection { padding: 60px 32px 80px; }
  }
}
</style>
